module.exports = __webpack_public_path__ + "src/assets/right_caret.png";